import TRTC from 'trtc-js-sdk';
// import { SDKAPPID } from './config';
// import { getLatestUserSig } from './getUserSig';

export const handleJoin = async ({ roomId, appId, userSig }) => {
  const client = new GetClient(appId, userSig);
  handleClientEvents(client);
  try {
    const stream = new GetStream();
    await client.join({ roomId });
    await stream.initialize();
    await client.publish(stream);
  } catch (error) {
    console.log('shareRTC handleJoin error = ', error);
    throw error;
  }
};

export const handleLeave = async ({ appId, userSig }) => {
  const client = new GetClient(appId, userSig);
  try {
    const stream = new GetStream();
    await stream.stop();
    stream.close();
    await client.unpublish(stream);
    await client.leave();
  } catch (error) {
    console.log('shareRTC handleLeave error = ', error);
    throw error;
  }
};
const handleClientEvents = (client) => {
  // 监听远端流订阅成功事件
  client.on('stream-subscribed', event => {
    const remoteStream = event.stream;
    // 远端流订阅成功，播放远端音视频流
    remoteStream.play('remote_stream');
  });
  // 监听远端流增加事件
  client.on('stream-added', event => {
    const remoteStream = event.stream;
    const remoteUserID = remoteStream.getUserId();
    if (remoteUserID === `share_${window.pageProps.operationUserId}`) {
      // don't need screen shared by us
      client.unsubscribe(remoteStream);
    } else {
      // 仅订阅音频数据
      client.subscribe(remoteStream, { audio: true, video: false }).catch(e => {
        console.error('failed to subscribe remoteStream');
      });
    }
  });
};
const GetClient = (function () {
  let client;
  return function (appId, userSig) {
    if (client) {
      return client;
    }
    const userId = window.pageProps ? window.pageProps.operationUserId.toString() : '';
    client = TRTC.createClient({
      mode: 'rtc',
      sdkAppId: appId,
      userId,
      userSig,
      autoSubscribe: false,
      bussinessInfo: JSON.stringify({
        Str_uc_params: {
          uc_biz_type: 1000,
        },
      }),
    });
    return client;
  };
}());

const GetStream = (function () {
  let stream;
  return function () {
    if (stream) {
      return stream;
    }
    const userId = window.pageProps ? window.pageProps.operationUserId.toString() : '';
    stream = TRTC.createStream({
      audio: true,
      screen: false,
      userId,
    });
    return stream;
  };
}());
